
import { Player, Tournament, Match, NewsArticle, Team, GameMode } from '../types';

export interface GameState {
  version?: string;
  mode: GameMode;
  players: Player[];
  tournaments: Tournament[];
  quickMatches: Match[];
  news: NewsArticle[];
  teams: Team[];
  doublesTournaments: Tournament[];
  doublesQuickMatches: Match[];
  doublesNews: NewsArticle[];
  customTickerMessage: string;
  commissionerReport: string | null;
  theme: 'void' | 'light';
  appLogo: string | null;
  connectionStatus: 'connecting' | 'connected' | 'error' | 'offline';
}

export class GameStore {
  private state: GameState;
  private listeners: Set<() => void>;

  constructor(initialState: GameState) {
    this.state = initialState;
    this.listeners = new Set();
  }

  getState(): GameState {
    return this.state;
  }

  setState(partialState: Partial<GameState> | ((prev: GameState) => Partial<GameState>)) {
    const updates = typeof partialState === 'function' 
      ? (partialState as (prev: GameState) => Partial<GameState>)(this.state)
      : partialState;
    this.state = { ...this.state, ...updates };
    this.notify();
  }

  // Specific setter for mode to be explicit
  setMode(mode: GameMode) {
    this.setState({ mode });
  }

  subscribe(listener: () => void): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  notify() {
    this.listeners.forEach(listener => listener());
  }

  destroy() {
    this.listeners.clear();
  }
}
